import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceContentsApply',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String
  },
  data () {
    return {
      loading: true,
      processing: false,
      
      // テーブルオプション
      tableColumns: [
        'priorityOrder',
        'appliedContentsId',
        'deliveryToKbn',
        'serviceContentsId',
        'snapshotName',
        'deviceType',
        'detailButton',
        'modifyButton',
        'deleteButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          priorityOrder: '優先順位',
          appliedContentsId: '適用コンテンツID',
          deliveryToKbn: '配信先',
          serviceContentsId: 'コンテンツID',
          snapshotName: 'スナップショット名',
          deviceType: '対象デバイス',
          detailButton: '',
          modifyButton: '',
          deleteButton: ''
        },
        columnsClasses: {
          priorityOrder: '',
          appliedContentsId: 'wp-5',
          deliveryToKbn: '',
          serviceContentsId: '',
          snapshotName: '',
          deviceType: '',
          detailButton: 'wp-5 has-button',
          modifyButton: 'wp-5 has-button',
          deleteButton: 'wp-5 has-button'
        },
        sortable: [
          'priorityOrder',
          'appliedContentsId',
          'deliveryToKbn',
          'serviceContentsId',
          'snapshotName',
          'deviceType'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 検索
      searchContents: '',
      searched: false,

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      deleteTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceContentsApply.categoryName,
      serviceName: state => state.serviceContentsApply.serviceName,

      // model
      contentsSettingModel: state => state.serviceContentsApply.contentsSettingModel,
      contentsApplyModel: state => state.serviceContentsApply.contentsApplyModel,
      updatedList: state => state.serviceContentsApplyRegistModal.updated,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept,
      
      // modal
      updatedSort: state => state.serviceContentsApplySortModal.updated
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    serviceContentsList () {
      let list = []
      this.contentsSettingModel.forEach(item => {
        let label = item.contentsName + ' ( serviceContentsId: '
                  + item.serviceContentsId + ' / serviceType: '
                  + item.serviceType + ' )'
        list.push({
          value: item.serviceContentsUuid,
          label: label
        })
      })
      return list
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // enable
    disableSelectContentsId () {
      return this.contentsSettingModel.length === 0
    },
    disableSearchButton () {
      return this.searchContents === ''
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 削除
      if (this.confirmKey === 'delete') {
        if (to) this.deleteData()
      }
    },
    updatedList: function (to) {
      console.log('updatedList', to)
      if (!to) return
      // モーダルで適用コンテンツの変更がされたら一覧を更新
      this.search()
    },
    updatedSort: function (to) {
      console.log('updatedList', to)
      if (!to) return
      // モーダルで適用コンテンツの変更がされたら一覧を更新
      this.search()
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceContentsApply/loadModel',
      loadContentsApplyList: 'serviceContentsApply/loadContentsApplyList',
      // modal
      showServiceContentsApplyConfirmModal: 'serviceContentsApplyConfirmModal/show',
      showServiceContentsApplyRegistModal: 'serviceContentsApplyRegistModal/show',
      showServiceContentsApplySortModal: 'serviceContentsApplySortModal/show'
    }),

    init () {
      this.loading = true

      //
      let contentsSettingParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        contentsSettingParams: contentsSettingParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.contentsApplyModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'deliveryToKbn':
          return Utility.getConstantsLabel(['ContentsApply', 'DeliveryToKbn'], value)
        case 'deliveryTypeStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 検索
    resetSearch () {
      this.searchContents = ''

      this.searched = false
    },
    search () {
      this.loading = true

      //
      let contentsApplyParams = {
        serviceUuid: this.serviceId
      }
      if (this.searchContents) {
        contentsApplyParams.filters = {
          serviceContentsUuid: this.searchContents
        }
      }

      // データ読出し
      this.loadContentsApplyList({
        contentsApplyParams: contentsApplyParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.contentsApplyModel)
          this.searched = true
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },
    
    registItem () {
      this.showServiceContentsApplyRegistModal({
        serviceId: this.serviceId,
        serviceContentsId: this.searchContents,
        appliedContentsId: Constants.RegisterHash
      })
    },
    sortItem () {
      this.showServiceContentsApplySortModal({
        serviceId: this.serviceId,
        serviceContentsId: this.searchContents
      })
    },
    detailItem (props) {
      this.showServiceContentsApplyConfirmModal({
        serviceId: this.serviceId,
        appliedContentsId: props.row.appliedContentsUuid
      })
    },
    modifyItem (props) {
      this.showServiceContentsApplyRegistModal({
        serviceId: this.serviceId,
        serviceContentsId: this.searchContents,
        appliedContentsId: props.row.appliedContentsUuid
      })
    },
    deleteItem (props) {
      this.deleteTargetId = props.row.appliedContentsUuid

      // confirm
      const id = Utility.getObjectArrayValue(this.contentsApplyModel, 'appliedContentsUuid', this.deleteTargetId, 'appliedContentsId')
      this.showConfirm({
        key: 'delete',
        title: '',
        body: '「Id : ' + id + '」の' + this.categoryName + 'を削除しますか？',
        acceptLabel: '削除'
      })
    },

    /**
     * データの削除
     */
    deleteData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        appliedContentsUuid: this.deleteTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceContentsApply'],
        ['v1ServiceContentsApplyDelete'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + '情報の削除',
              body: this.categoryName + 'を削除しました。'
            })

            this.deleteTargetId = null

            // 一覧データを再読出し
            this.search()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
  }
}